import { IconButton, Tooltip, makeStyles, withStyles } from "@material-ui/core";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React from "react";

export interface SectionInfoTooltipProps {
    content: string;
    marginLeft?: string;
}

const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: "#fff",
        color: "#374151",
        maxWidth: 320,
        fontSize: theme.typography.pxToRem(13),
        border: "1px solid #e5e7eb",
        boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.12), 0px 2px 6px rgba(0, 0, 0, 0.08)",
        borderRadius: "10px",
        padding: "10px 14px",
        lineHeight: "1.6",
        fontWeight: 400,
        display: "flex",
        alignItems: "flex-start",
        gap: "8px",
    },
    arrow: {
        color: "#fff",
        "&::before": {
            border: "1px solid #e5e7eb",
            boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
        },
    },
}))(Tooltip);

const useStyles = makeStyles((theme) => ({
    iconButton: {
        padding: "4px",
        marginLeft: "8px",
        verticalAlign: "middle",
        "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.04)",
        },
    },
    icon: {
        fontSize: "1.1rem",
        color: "rgba(0, 0, 0, 0.54)",
        transition: "color 0.2s ease",
        "&:hover": {
            color: theme.palette.primary.main,
        },
    },
}));

export const SectionInfoTooltip: React.FC<SectionInfoTooltipProps> = ({
    content,
    marginLeft = "6px"
}) => {
    const classes = useStyles();

    const tooltipContent = (
        <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
            <InfoOutlinedIcon style={{ fontSize: "16px", color: "#3b82f6", marginTop: "2px", flexShrink: 0 }} />
            <span>{content}</span>
        </div>
    );

    return (
        <HtmlTooltip title={tooltipContent} arrow placement="top" enterDelay={200} style={{ marginLeft: marginLeft }}>
            <IconButton className={classes.iconButton} size="small">
                <HelpOutlineIcon className={classes.icon} />
            </IconButton>
        </HtmlTooltip>
    );
};

